<template>
  <div class="page-link-areas absolute inset-0">
    <svg width="100%" height="100%" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <a v-for="link of page.links" :key="link.id" :href="link.url" target="_blank">
        <rect v-bind="linkProps(link)" stroke="#FF69B4" fill="transparent" stroke-width="0" />
      </a>
    </svg>
    <span v-for="link of page.links" :key="'dot' + link.id" class="dot" :style="dotStyle(link)" />
  </div>
</template>

<script>
// Clickable areas for a page's links, drawn over the page image. Mouse users see an outline on hover. Touchscreens
// have no hover, so they get a pulsing dot in the middle of each link instead.
export default {
  props: {
    page: { type: Object, required: true },
  },
  methods: {
    linkProps(link) {
      // We use a percentage to handle the fact that the image will likely be resized (shrunk) when shown.
      return {
        x: (100 * link.xPercentage) + '%',
        y: (100 * link.yPercentage) + '%',
        width: (100 * link.widthPercentage) + '%',
        height: (100 * link.heightPercentage) + '%',
      }
    },
    dotStyle(link) {
      return {
        left: (100 * (link.xPercentage + link.widthPercentage / 2)) + '%',
        top: (100 * (link.yPercentage + link.heightPercentage / 2)) + '%',
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
link-color = #FF69B4

rect:hover
  stroke-width 4px

.dot
  display none
  position absolute
  width 14px
  height 14px
  margin -7px 0 0 -7px
  border-radius 50%
  background link-color
  border 2px solid white
  box-shadow 0 1px 3px rgba(0, 0, 0, .4)
  pointer-events none
  opacity .75

  @media (hover: none)
    display block
    animation pulse 1.4s ease-out 4

@keyframes pulse
  0%
    box-shadow 0 1px 3px rgba(0, 0, 0, .4), 0 0 0 0 rgba(255, 105, 180, .7)
    opacity 1
  100%
    box-shadow 0 1px 3px rgba(0, 0, 0, .4), 0 0 0 16px rgba(255, 105, 180, 0)
    opacity 1

@media (prefers-reduced-motion: reduce)
  .dot
    animation none !important
</style>
